import React, { createContext, useState } from 'react';

export const SelectionContext = createContext();

export function SelectionProvider({ children }) {
  const [expandedList,        setExpandedList]        = useState( [] );
  const [expandedDefaultList, setExpandedDefaultList] = useState( [] );
  const [orderEditEnabled,    setOrderEditEnabled]    = useState( false );
  const [clSummaryPos,        setClSummaryPos    ]    = useState( 0 );
  const [wkSummaryPos,        setWkSummaryPos    ]    = useState( 0 );
  const [expandedCLState,     setExpandedCLState]     = useState( false );
  const [expandedWkState,     setExpandedWkState]     = useState( false );
  const [sysMsgDismissed,     setSysMsgDismissed]     = useState( false );
  
  /******************************************************************
   * getSysMessageDismissed( ) - retrieve the status for sysMessage *
   ******************************************************************/
  const getSysMessageDismissed = ( ) => {
      return ( sysMsgDismissed );      
  };

  /******************************************************************
   * setSysMessageDismissed( ) - retrieve the status for sysMessage *
   ******************************************************************/
  const setSysMessageDismissed = ( v ) => {
      setSysMsgDismissed( v );      
  };

  /*************************************************************************
   * getExpandedWkSummary( ) - retrieve the expanded status for Wk Summary *
   *************************************************************************/
  const getExpandedWkSummary = ( ) => {
      return ( expandedWkState );      
  };

  /*************************************************************************
   * setExpandedWkSummary( v ) - set the expanded status for Wk Summary    *
   *************************************************************************/
  const setExpandedWkSummary = ( v ) => {
      setExpandedWkState( v ); 
  };
  
  /*************************************************************************
   * toggleExpandedWkSummary( ) - flip the expanded status for Wk Summary  *
   *************************************************************************/
  const toggleExpandedWkSummary = () => {
      setExpandedWkState( !expandedWkState ); 
  };
  
  /*************************************************************************
   * getExpandedCLSummary( ) - retrieve the expanded status for CL Summary *
   *************************************************************************/
  const getExpandedCLSummary = ( ) => {
      return ( expandedCLState );      
  };

  /*************************************************************************
   * setExpandedCLSummary( v ) - set the expanded status for CL Summary    *
   *************************************************************************/
  const setExpandedCLSummary = ( v ) => {
      setExpandedCLState( v ); 
  };
  
  /*************************************************************************
   * toggleExpandedCLSummary( ) - flip the expanded status for CL Summary  *
   *************************************************************************/
  const toggleExpandedCLSummary = () => {
      setExpandedCLState( !expandedCLState ); 
  };
  
  /****************************************************************
   * getExpanded( id ) - retrieve the expanded status for goal id *
   ****************************************************************/
  const getExpanded = ( id ) => {
      for ( let i = 0; i < expandedList.length; i++) {
          if ( expandedList[i].id === id ) {
             return ( expandedList[i].value );
          }
      }
      setExpanded( id, false );
      return( false );
  };

  /******************************************************************
   * setExpanded( id, v ) - set the expanded state to v for goal id *
   ******************************************************************/
  const setExpanded = ( id, v ) => {
      var found = false;
      for ( let i = 0; i < expandedList.length; i++) {
          if ( expandedList[i].id === id ) {
              setExpandedList(prevItems => {
                  const updated = [...prevItems];  // clone the array
                  updated[i].value = v === 1;            // update the specific item
                  return updated;
                  });
              found = true;
          }
      }
      if ( !found ){
          setExpandedList(prevItems => [...prevItems, { id: id, value: v }] );
      }
  };

  /***************************************************************************
   * initExpanded( id, v ) - set the default expanded state to v for goal id *
   ***************************************************************************/
  const initExpanded = ( id, v ) => {
      var found = false;
      for ( let i = 0; i < expandedDefaultList.length; i++) {
          if ( expandedDefaultList[i].id === id ) {
              found = true;
          }
      }
      if ( !found ){
          setExpandedDefaultList(prevItems => [...prevItems, { id: id, value: v }] );
          setExpanded( id, v === 1 );
      }
  };

  /***********************************************************************
   * toggleExpanded( id ) - toggle the state of expanded property for id *
   ***********************************************************************/
  const toggleExpanded = ( id ) => {
      var found = false;
      for ( let i = 0; i < expandedList.length; i++) {
          if ( expandedList[i].id === id ) {
              const newVal = !expandedList[i].value;
              setExpandedList(prevItems => {
                  const updated = [...prevItems];  // clone the array
                  updated[i].value = newVal;       // update the specific item
                  return updated;
                  });
              found = true;
          }
      }
      if ( !found ){
          setExpandedList(prevItems => [...prevItems, { id: id, value: false }] );
      }
  };

  /**************************************************
   * enableOrderEdit( ) - enable order editing mode *
   **************************************************/
  const enableOrderEdit = (  ) => {
      setOrderEditEnabled( true );
  };
  
  /****************************************************
   * disableOrderEdit( ) - disable order editing mode *
   ****************************************************/
  const disableOrderEdit = (  ) => {
      setOrderEditEnabled( false );
  };

  /******************************************************
   * updateClSummaryPos( p ) -set the checklist summary *
   * position                                           *
   ******************************************************/
  const updateClSummaryPos = ( p ) => {
      setClSummaryPos( p );
  };

  /******************************************************
   * updateWkSummaryPos( p ) -set the weekly summary    *
   * position                                           *
   ******************************************************/
  const updateWkSummaryPos = ( p ) => {
      setWkSummaryPos( p );
  };
  
  return (
    <SelectionContext.Provider value={{ getExpandedWkSummary, setExpandedWkSummary, toggleExpandedWkSummary,
                                      getExpandedCLSummary, setExpandedCLSummary, toggleExpandedCLSummary, 
                                      getExpanded, setExpanded, toggleExpanded, initExpanded, 
                                      orderEditEnabled, enableOrderEdit, disableOrderEdit, clSummaryPos, updateClSummaryPos, wkSummaryPos, updateWkSummaryPos,
                                      getSysMessageDismissed, setSysMessageDismissed}}>
      {children}
    </SelectionContext.Provider>
  );
}
